module.exports = __webpack_public_path__ + "images/emoji/baby_chick.30b609ed90124892eca8.png";